import { BaseModel } from './base.model';
import { Society } from './society.model';

export interface Department {
    id: number;
    name: string;
    description: string;
    headDepartmentId: string;
    location: string;
    society: Society;
  }

  export class Department implements BaseModel {
    id: number;
    name: string;
    description: string;
    headDepartmentId: string;
    location: string;
    society: Society;

    constructor();
    constructor(id: number, name: string, description: string, headDepartmentId: string, location: string, society: Society);

    constructor(id?: number, name?: string, description?: string, headDepartmentId?: string, location?: string, society?: Society) {
      if (id !== undefined) {
        this.id = id;
      }
      if (name !== undefined) {
        this.name = name;
      } else {
        this.name = '';
      }

      if (description !== undefined) {
        this.description = description;
      } else {
        this.description = '';
      }

      if (headDepartmentId !== undefined) {
        this.headDepartmentId = headDepartmentId;
      } else {
        this.headDepartmentId = '';
      }

      if (location !== undefined) {
        this.location = location;
      } else {
        this.location = '';
      }

      if (society !== undefined) {
        this.society = society;
      } else {
        this.society = {} as Society;
      }
    }

    getApiName(): string {
      return 'department';
    }

    getName(): string {
      return 'Departamento';
    }

    getNamePl(): string {
      return 'Departamentos';
    }
  }
